// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcs_a bhl_ea bhl_kb bhl_js bhl_sl bhl_wj"};